import { push } from 'connected-react-router';

export default (reportId) => push(`/report-review-pro/${reportId}`);
